<template>
  <section>
    <b-card class="mb-1 sticky-top" style="height: 58px; font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body>
      <b-row>
        <b-col cols="10">
          <b-row class="d-flex align-items-center justify-content-start">
            <span class="bg-primary round text-white ml-2" style="width: 80px; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">기간</span>
            <flat-pickr
              class="form-control border-2"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
              placeholder="YYYY-MM ~ YYYY-MM"
              :config="configs.monthSelect" 
              :value="form.monthSelect"
              @on-open="datePickerOnOpen"
              @on-change="datePickerOnChange"
              @on-close="datepickerCloseHandler"
            />
          </b-row>                   
        </b-col>
        <b-col cols="2">
          <b-row class="d-flex align-items-center justify-content-end">
            <b-button id="exp_pdf" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToPDF">
              <div v-if="isPdfExporting" class="spinner-border spinner-border-sm"></div>
              <div v-else>
                <i class="fa-regular fa-file-pdf fa-lg"/>
              </div>
            </b-button>
            <b-tooltip target="exp_pdf" triggers="hover"> Export to PDF </b-tooltip>
            <b-button id="exp_xls" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToExcel">
              <div v-if="isXlsExporting" class="spinner-border spinner-border-sm"></div>
              <div v-else>
                <i class="fa-regular fa-file-excel fa-lg"/>
              </div>
            </b-button>    
            <b-tooltip target="exp_xls" triggers="hover"> Export to Excel </b-tooltip> 
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <div ref="trkPrintArea">
      <b-card class="mb-1" style="max-height: 200px; font-family: NanumBarunGothic; padding: 0.3rem 1.5rem 1.0rem 1.5rem;" no-body>
        <b-row>
          <b-col cols="12">
            <b-row class="trkvsellabel d-flex justify-content-center mb-1">
              <v-select
                id="sel-brands"
                v-model="filterData.brands"
                :items="optionData.brands"
                :closeOnSelect=false
                :menu-props="{ contentClass: 'trkselectitemlist' }"
                label="브랜드"
                multiple
                clearable
                hide-details
                style="width: 19%; height: auto; margin: 5px; text-align: center !important;"
                @change="changeFilter('brand')"
              >
                <template v-slot:no-data >
                  <em style="margin-left: 10px; opacity: 0.5; font-size: 12px;">해당하는 브랜드가 없습니다.</em>
                </template>
                <template v-slot:prepend-item>
                  <v-checkbox
                    v-if="optionData.brands.length > 1"
                    class="trkselectallitem"
                    v-model=isSelectAll_brands
                    :color="isSelectAll_brands ? '#1817E7' : 'undefined'"
                    :indeterminate="isSelectSome_brands && !isSelectAll_brands"
                    :ripple="false"
                    hide-details
                    @click="selectAll('brand')"
                  >
                    <template v-slot:label>
                      <span style="color: #1817E7; font-size: 12px; font-weight: 600; padding: 0px; margin: 2px 0px 0px 5px;">(모두 선택)</span>
                    </template>
                  </v-checkbox>
                  <v-divider v-if="optionData.brands.length > 1" class="trkdivider" />
                </template>
                <template v-slot:selection="{item, index}">
                  <v-chip v-if="index < maxDisplay" style="height: 24px; font-size: 10px; font-weight: 500;" x-small close @click:close="removeSelItem('brand', filterData.brands, index)">{{ item }}</v-chip>
                  <span
                    v-if="index === maxDisplay"
                    class="caption ml-1"
                    style="color:#5e5873; font-family: NanumBarunGothic !important; font-weight: 600; margin-top: 3px;"
                    >(+{{ filterData.brands.length - maxDisplay }} 브랜드)
                  </span>
                </template>
              </v-select>
              <v-select
                id="sel-majors"
                v-model="filterData.majors"
                :items="optionData.majors"
                :closeOnSelect="false"
                :menu-props="{ contentClass: 'trkselectitemlist' }"
                label="대분류(전체)"
                multiple
                clearable
                hide-details
                style="width: 19%; height: auto; margin: 5px; text-align: center !important;"
                @change="changeFilter('major')"
              >
                <template v-slot:no-data >
                  <em style="margin-left: 10px; opacity: 0.5; font-size: 12px;">해당하는 대분류가가 없습니다.</em>
                </template>
                <template v-slot:prepend-item>
                  <v-checkbox
                    v-if="optionData.majors.length > 1"
                    class="trkselectallitem"
                    v-model=isSelectAll_majors
                    :color="isSelectAll_majors ? '#1817E7' : 'undefined'"
                    :indeterminate="isSelectSome_majors && !isSelectAll_majors"
                    :ripple="false"
                    hide-details
                    @click="selectAll('major')"
                  >
                    <template v-slot:label>
                      <span style="color: #1817E7; font-size: 12px; font-weight: 600; padding: 0px; margin: 2px 0px 0px 5px;">(모두 선택)</span>
                    </template>
                  </v-checkbox>
                  <v-divider v-if="optionData.majors.length > 1" class="trkdivider" />
                </template>
                <template v-slot:selection="{item, index}">
                  <v-chip v-if="index < maxDisplay" style="height: 24px; font-size: 12px; font-weight: 500;" x-small close @click:close="removeSelItem('major', filterData.majors, index)">{{ item }}</v-chip>
                  <span
                    v-if="index === maxDisplay"
                    class="caption ml-1"
                    style="color:#5e5873; font-family: NanumBarunGothic !important; font-weight: 600; margin-top: 3px;"
                    >(+{{ filterData.majors.length - maxDisplay }} 대분류)
                  </span>
                </template>
              </v-select>
              <v-select
                id="sel-middles"
                v-model="filterData.middles"
                :items="optionData.middles"
                :closeOnSelect="false"
                :menu-props="{ contentClass: 'trkselectitemlist' }"
                label="중분류(전체)"
                multiple
                clearable
                hide-details
                style="width: 19%; height: auto; margin: 5px; text-align: center !important;"
                @change="changeFilter('middle')"
              >
                <template v-slot:no-data>
                  <em style="margin-left: 10px; opacity: 0.5; font-size: 12px;">해당하는 중분류가가 없습니다.</em>
                </template>
                <template v-slot:prepend-item>
                  <v-checkbox
                    v-if="optionData.middles.length > 1"
                    class="trkselectallitem"
                    v-model=isSelectAll_middles
                    :color="isSelectAll_middles ? '#1817E7' : 'undefined'"
                    :indeterminate="isSelectSome_middles && !isSelectAll_middles"
                    :ripple="false"
                    hide-details
                    @click="selectAll('middle')"
                  >
                    <template v-slot:label>
                      <span style="color: #1817E7; font-size: 12px; font-weight: 600; padding: 0px; margin: 2px 0px 0px 5px;">(모두 선택)</span>
                    </template>
                  </v-checkbox>
                  <v-divider v-if="optionData.middles.length > 1" class="trkdivider" />
                </template>
                <template v-slot:selection="{item, index}">
                  <v-chip v-if="index < maxDisplay" style="height: 24px; font-size: 12px; font-weight: 500;" x-small close @click:close="removeSelItem('middle', filterData.middles, index)">{{ item }}</v-chip>
                  <span
                    v-if="index === maxDisplay"
                    class="caption ml-1"
                    style="color:#5e5873; font-family: NanumBarunGothic !important; font-weight: 600; margin-top: 3px;"
                    >(+{{ filterData.middles.length - maxDisplay }} 중분류)
                  </span>
                </template>
              </v-select>
              <v-select
                id="sel-prop"
                v-model="filterData.prop"
                :items="optionData.prop"
                :closeOnSelect="false"
                :menu-props="{ contentClass: 'trkselectitemlist' }"
                label="속성(전체)"
                multiple
                clearable
                hide-details
                @change="changeFilter('prop')"
                style="width: 19%; height: auto; margin: 5px; text-align: center !important;"
              >
                <template v-slot:no-data >
                  <em style="margin-left: 10px; opacity: 0.5; font-size: 12px;">해당하는 속성이 없습니다.</em>
                </template>
                <template v-slot:prepend-item>
                  <v-checkbox
                    v-if="optionData.prop.length > 1"
                    class="trkselectallitem"
                    v-model=isSelectAll_props
                    :color="isSelectAll_props ? '#1817E7' : 'undefined'"
                    :indeterminate="isSelectSome_props && !isSelectAll_props"
                    :ripple="false"
                    hide-details
                    @click="selectAll('prop')"
                  >
                    <template v-slot:label>
                      <span style="color: #1817E7; font-size: 12px; font-weight: 600; padding: 0px; margin: 2px 0px 0px 5px;">(모두 선택)</span>
                    </template>
                  </v-checkbox>
                  <v-divider v-if="optionData.prop.length > 1" class="trkdivider" />
                </template>
                <template v-slot:selection="{item, index}">
                  <v-chip v-if="index < maxDisplay" style="height: 24px; font-size: 12px; font-weight: 500;" x-small close @click:close="removeSelItem('prop', filterData.prop, index)">{{ item }}</v-chip>
                  <span
                    v-if="index === maxDisplay"
                    class="caption ml-1"
                    style="color:#5e5873; font-family: NanumBarunGothic !important; font-weight: 600; margin-top: 3px;"
                    >(+{{ filterData.prop.length - maxDisplay }} 속성)
                  </span>
                </template>
              </v-select>
              <v-select
                id="sel-prop-details"
                v-model="filterData.prop_d"
                :items="optionData.prop_d"
                :closeOnSelect="false"
                :menu-props="{ contentClass: 'trkselectitemlist' }"
                label="세부 속성(전체)"
                multiple
                clearable
                hide-details
                style="width: 19%; height: auto; margin: 5px; text-align: center !important;"
                @change="changeFilter('prop_d')"
              >
                <template v-slot:no-data >
                  <em style="margin-left: 10px; opacity: 0.5; font-size: 12px;">속성 항목을 선택하세요.</em>
                </template>
                <template v-slot:prepend-item>
                  <v-checkbox
                    v-if="optionData.prop_d.length > 1"
                    class="trkselectallitem"
                    v-model=isSelectAll_prop_details
                    :color="isSelectAll_prop_details ? '#1817E7' : 'undefined'"
                    :indeterminate="isSelectSome_prop_details && !isSelectAll_prop_details"
                    :ripple="false"
                    hide-details
                    @click="selectAll('prop_detail')"
                  >
                    <template v-slot:label>
                      <span style="color: #1817E7; font-size: 12px; font-weight: 600; padding: 0px; margin: 2px 0px 0px 5px;">(모두 선택)</span>
                    </template>
                  </v-checkbox>
                  <v-divider v-if="optionData.prop_d.length > 1" class="trkdivider" />
                </template>
                <template v-slot:selection="{item, index}">
                  <v-chip v-if="index < maxDisplay" style="height: 24px; font-size: 12px; font-weight: 500;" x-small close @click:close="removeSelItem('prop_d', filterData.prop_d, index)">{{ item }}</v-chip>
                  <span
                    v-if="index === maxDisplay"
                    class="caption ml-1"
                    style="color:#5e5873; font-family: NanumBarunGothic !important; font-weight: 600; margin-top: 3px;"
                    >(+{{ filterData.prop_d.length - maxDisplay }} 세부 속성)
                  </span>
                </template>
              </v-select>
            </b-row>
            <b-row>
              <div style="margin-left: 40%; margin-bottom: -8px; padding: 0px; padding-left: 3px; font-size: 11px; color: #17a2b8;">
                ▪ <b>'중분류 없음'</b>은 대분류에서 어느 중분류에도 해당하지 않는 <b>모든 값</b>을 의미합니다.
              </div>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <b-card class="mb-0" style="font-family: NanumBarunGothic; padding: 0.2rem 1.5rem;" no-body>
        <b-row>
          <b-col cols="6" style="text-align: left; color:whitesmoke; font-size: 14px; margin-left: 1.0rem; margin-top: 1.0rem; padding: 5px; background-color:lightslategray; border-radius: 5px;">
            💡 세부 단위 트래킹을 활용하여, 특정 속성에 대한 관심이 증가 또는 감소하는지 확인할 수 있습니다. <br/>
            💡 캠페인/프로모션 활동의 목표에 해당하는 영역을 활동 전후로 비교하여 한눈에 성과분석 해 볼 수 있습니다.
          </b-col>
        </b-row>
        <b-row style="margin-top: 10px;">
          <b-col cols="9" class="d-flex align-items-center justify-content-start">
            <b-card-title class="ml-3" style="margin: 0.1rem;"><h2><b>{{ trkTitle }}</b></h2></b-card-title>
          </b-col>
          <b-col cols="3">
            <div class="d-flex justify-content-end mb-1">
              <v-select
                id="sel-datetype"
                :items="optionData.dateType"
                v-model="filterData.dateType"
                label="기간"
                dense
                outlined
                hide-details
                @change="filterPeriodChange"
                style="width: 100px; height: auto; font-size: 12px; font-weight: 500; margin: 5px; text-align: center !important;"
              />
              <v-select
                id="sel-display"
                :items="optionData.displayType"
                :value="filterData.displayType"
                label="표기"
                dense
                outlined
                hide-details
                @change="filterDisplayChange"
                style="width: 100px; height: auto; font-size: 12px; font-weight: 500; margin: 5px; text-align: center !important;"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: center; color: #ea5455; margin-bottom: 0rem;">
            📢 아래에서 원하는 그래프 기준값(범례)을 선택하면 그래프가 생성됩니다.
          </b-col>
        </b-row>
        <b-row class="d-flex align-items-center justify-content-center mr-1 mb-1">
          <b-button-group>
            <b-button 
              class="dsp-opt-btn" 
              v-for="(btn, idx) in dsp_buttons"
              :key="idx"
              :pressed.sync="btn.state"
              @click="filterLegendChange(idx)"
            >
              {{ btn.caption }}
            </b-button>
          </b-button-group>
        </b-row>
        <b-row>
          <b-col cols="12" style="position: relative;">
            <div id="loadingLine" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%; visibility: visible;">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>분석중...</strong>
            </div>
            <div id="lineChart" style="visibility: hidden;">
              <tracking-line-chart
                :chartCategories="lineChartCategories"
                :trackingLineChart="lineChartSeries"
                :chartHeight="lnChartHeight"
                :isChartInit="lnChartInit"
                :chartPeriodType="this.filterData.dateType"
              />
            </div>
            <div v-if="this.lnChartInit" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin: 5px;">          
              <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
                <div v-if="this.lineChartData.length == 1" style="margin-bottom: 4px;">
                  • <b>{{ this.lineChartCategories[this.lineChartCategories.length - 1] }}</b> 기간에 <b>{{ this.filterData.legendType }}</b> 검색량은 <b>{{ this.lineChartData[0].criteria }}</b> 입니다. 
                </div>
                <div v-else-if="this.lineChartData.length == 2" style="margin-bottom: 4px;">
                  • <b>{{ this.lineChartCategories[this.lineChartCategories.length - 1] }}</b> 기간에 <b>{{ this.filterData.legendType }}</b> 검색량 순위는 🥇<b>{{ this.lineChartData[0].criteria }}</b>, 🥈<b>{{ this.lineChartData[1].criteria }}</b> 순 입니다. 
                </div>
                <div v-else-if="this.lineChartData.length > 2" style="margin-bottom: 4px;">
                  • <b>{{ this.lineChartCategories[this.lineChartCategories.length - 1] }}</b> 기간에 <b>{{ this.filterData.legendType }}</b> 검색량 순위는 🥇<b>{{ this.lineChartData[0].criteria }}</b>, 🥈<b>{{ this.lineChartData[1].criteria }}</b>, 🥉<b>{{ this.lineChartData[2].criteria }}</b> 순 입니다. 
                </div>
                <div v-if="this.filterData.displayType == '검색량'" style="margin-bottom: 4px;">
                  • 조회 기간 중 가장 많이 검색된 <b>{{ this.filterData.legendType }}</b>는 <b>{{ this.top_freq_brand }}</b>로 <b>{{ this.top_freq_date }}</b> 기간에 <b>{{ this.top_freq_value.toLocaleString() }}</b> 건의 검색량을 보였습니다.
                </div>
                <div v-else style="margin-bottom: 4px;">
                  • 조회 기간 중 가장 많이 검색된 <b>{{ this.filterData.legendType }}</b>는 <b>{{ this.top_freq_brand }}</b>로 <b>{{ this.top_freq_date }}</b> 기간에 <b>{{ this.top_freq_rate.toFixed(2) }}%</b> 의 비율을 보였습니다.
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </section>
</template>

<script>
import { 
  BCard,
  BCardText,
  BCardBody, 
  BCardTitle,
  BTable, 
  BPagination,
  BCol, 
  BRow,     
  BFormRadio, 
  BFormGroup,
  BFormSelect,
  BFormInput,
  BButton,
  BButtonGroup,
  BTooltip,
  BSpinner,
} from "bootstrap-vue";

import FlatPickr from "vue-flatpickr-component";
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'

import 'flatpickr/dist/plugins/monthSelect/style.css'

import moment from "moment";

import ToastificationContent from "@core/components/toastification/ToastificationContent";

import TrackingLineChart from "@/views/cis-tracking/components/TrackingLineChart.vue";

import TrackingService from "@/services/cis-tracking.service";
import CategoryService from "@/services/category.service";

import ExportPDF from "@/components/pdfExport";
import debounce from "lodash";

import * as XLSX from 'xlsx';

import axios from "axios"

const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

const boldStyle = { font: { name: 'Consolas', bold: true } };
const underlineStyle = { font: { name: 'Consolas', underline: true} };

const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));

const colNameDict = {
  '추천/순위/종류': 'reco_rank_type',
  '비교/후기': 'comp_review',
  '등급': 'grade',
  '신체부위/증상': 'body_parts',
  '단점/부작용': 'side_effect',
  '인물/광고': 'person_ad',
  '기간': 'season_period', 
  '국가': 'country', 
  '지역': 'region', 
  '성별': 'gender', 
  '연령대': 'age_range', 
  '대상': 'target', 
  '기능': 'function',
  '색상': 'color',
  '디자인': 'design', 
  '소재/원료': 'material', 
  '맛': 'taste', 
  '형태': 'shape', 
  '용량/크기': 'size', 
  '두께/무게': 'weight', 
  '공간/장소': 'place', 
  '용도/목적': 'purpose',
  '생산/가공': 'manufacture',
  '차량종류': 'car_type',
  '계약내용': 'contract_details',
  '금리': 'interest_rate',
  '담보': 'pawn',
  '먹거리': 'food',
  '볼거리': 'attractions',
  '놀거리': 'activities',
  '숙박': 'accommodations',
  '교통수단': 'transportation',
  '시트/크림': 'sheet_cream',
  '토핑': 'toppings',
  '생산국': 'prod_country',
  '연식': 'model_year',
  '겉감': 'outshell',
  '충전재': 'filling',
  '기장': 'length',
  '핏': 'fit',
  '패턴/프린트': 'pattern',
  '넥라인': 'neckline',
  '디테일/부자재': 'trimmings',
  '렌탈': 'rental',
  '사용료': 'fee',
  '가격/프로모션': 'price_promotion',
  '가입/구매': 'join_purchase',
  '구매처': 'place_purchase',
  '설치/시공': 'installation',
  '사용': 'usage',
  '고장/에러코드': 'failure_errcd',
  '부품/소모품': 'parts',
  '케어서비스': 'care_service',
  '멤버십/회원': 'membership',
  'AS/고객센터': 'as_center',
  '청소': 'cleaning',
  '불만사항': 'complaint',
  '폐기/해지': 'discard_cancel',
  '긍정/부정': 'pos_neg'
}

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

var sel_category = '9999';

export default {
    name: "Tracking",
    components: {
      FlatPickr,

      BCard,
      BCardText,
      BCardBody, 
      BCardTitle,
      BTable, 
      BPagination,
      BCol, 
      BRow,     
      BFormRadio, 
      BFormGroup,
      BFormSelect,
      BFormInput,
      BButton,
      BButtonGroup,
      BTooltip,
      BSpinner,

      TrackingLineChart,
    },
    data() {
      return {
        isPdfExporting: false,            
        isXlsExporting: false,
        lnChartInit: false,
        lnChartHeight: "auto",

        maxDisplay: 1,

        lineChartCategories: [],
        lineChartData: [],

        selectedDates: [],

        filterData: {
          brands: [],
          majors: [],
          middles: [],
          prop: [],
          prop_d: [],
          dateType: "",
          legendType: "",
          displayType: "", 
        },

        optionData: {
          brands: [],
          majors: [],
          middles: [],
          prop: [],
          prop_d: [],
          dateType: ['일', '주', '월', '년'],
          legendType: ['브랜드', '라인 브랜드', '상품명', '대분류', '중분류', '속성', '세부 속성', '키워드'],
          displayType: ['비율(%)', '검색량'], 
        },

        form: {
          monthSelect: []
        },
        configs: {
          monthSelect: {
            mode: "range",
            altFormat: 'Y-m',
            plugins: [
              new monthSelectPlugin({
                shorthand: true,
                dateFormat: "Y-m",
              })
            ],
            locale: {
              rangeSeparator: ' ~ ',
            },
            minDate:"2018-01-01",
            maxDate: moment().endOf('month').format('YYYY-MM-DD') // 이번 달 말일로 지정
          },
        },

        dsp_buttons: [
          { caption: '브랜드', state: false },
          { caption: '라인 브랜드', state: false },
          { caption: '상품명', state: false },
          { caption: '대분류', state: false },
          { caption: '중분류', state: false },
          { caption: '속성', state: false },
          { caption: '세부 속성', state: false },
          { caption: '키워드', state: false },
        ],

        top_freq_brand: "",
        top_freq_date: "",
        top_freq_value: 0,
        top_freq_rate: 0.0,
      };
    },
    computed: {
      trkTitle() {
        for (var btn_idx = 0; btn_idx < this.dsp_buttons.length; btn_idx++) {
          if (this.dsp_buttons[btn_idx].state)
            return "TRACKING ➖ " + this.dsp_buttons[btn_idx].caption
        }

        return "TRACKING"
      },

      check_selectedCategory(){
        console.log('---------- computed // check_selectedCategory ----------')
        console.log(' sel category : ' + this.$store.getters.getSelectedCategory)

        return this.$store.getters.getSelectedCategory
      },

      isSelectAll_brands: {
        get() {
          return this.optionData.brands.length == this.filterData.brands.length 
        },
        set() {
        }
      },

      isSelectSome_brands: {
        get() {
          return this.filterData.brands.length > 0
        },
        set() {
        }
      },

      isSelectAll_majors: {
        get() {
          return this.optionData.majors.length == this.filterData.majors.length 
        },
        set() {
        }
      },

      isSelectSome_majors: {
        get() {
          return this.filterData.majors.length > 0
        },
        set() {
        }
      },

      isSelectAll_middles: {
        get() {
          return this.optionData.middles.length == this.filterData.middles.length 
        },
        set() {
        }
      },

      isSelectSome_middles: {
        get() {
          return this.filterData.middles.length > 0
        },
        set() {
        }
      },

      isSelectAll_props: {
        get() {
          return this.optionData.prop.length == this.filterData.prop.length 
        },
        set() {
        }
      },

      isSelectSome_props: {
        get() {
          return this.filterData.prop.length > 0
        },
        set() {
        }
      },

      isSelectAll_prop_details: {
        get() {
          return this.optionData.prop_d.length == this.filterData.prop_d.length 
        },
        set() {
        }
      },

      isSelectSome_prop_details: {
        get() {
          return this.filterData.prop_d.length > 0
        },
        set() {
        }
      },

      lineChartSeries() {
        return this.lineChartData.map(item => ({
          name: item.criteria,
          data: item.data,
          hidden: item.hidden,
        }));
      },
    },
    watch: {
      check_selectedCategory(val){
        console.log('---------- watch // check_selectedCategory ----------')
        console.log(' sel category : ' + val)
        console.log(' cur category : ' + sel_category)

        if (sel_category != val) {
          this.abort(true, 'change category')

          sel_category = val;

          var [st_dt, en_dt] = this.form.monthSelect

          this.filterData.brands = [];
          this.filterData.majors = [];
          this.filterData.middles = [];
          this.filterData.prop = [];
          this.filterData.prop_d = [];

          for (var btn_idx = 0; btn_idx < this.dsp_buttons.length; btn_idx++)
            this.dsp_buttons[btn_idx].state = false;

          this.loadData(moment(st_dt).format("YYYY-MM"), moment(en_dt).format("YYYY-MM"));
        }
      },
    },
    methods: {
      changeFilter(type){
        switch(type){
          case 'brand':
            if(this.filterData.brands.length == 0 || this.filterData.brands.length == this.optionData.brands.length){
              document.getElementById('sel-brands').parentNode.parentNode.querySelector("label[for='sel-brands']").innerHTML = '브랜드(전체)'
            }else{
              document.getElementById('sel-brands').parentNode.parentNode.querySelector("label[for='sel-brands']").innerHTML = '브랜드'
            }
            break;
          case 'major':
            if(this.filterData.majors.length == 0 || this.filterData.majors.length == this.optionData.majors.length){
              document.getElementById('sel-majors').parentNode.parentNode.querySelector("label[for='sel-majors']").innerHTML = '대분류(전체)'
            }else{
              document.getElementById('sel-majors').parentNode.parentNode.querySelector("label[for='sel-majors']").innerHTML = '대분류'
            }
            break;
          case 'middle':
            if(this.filterData.middles.length == 0 || this.filterData.middles.length == this.optionData.middles.length){
              document.getElementById('sel-middles').parentNode.parentNode.querySelector("label[for='sel-middles']").innerHTML = '중분류(전체)'
            }else{
              document.getElementById('sel-middles').parentNode.parentNode.querySelector("label[for='sel-middles']").innerHTML = '중분류'
            }
            break;
          case 'prop':
            if(this.filterData.prop.length == 0 || this.filterData.prop.length == this.optionData.prop.length){
              document.getElementById('sel-prop').parentNode.parentNode.querySelector("label[for='sel-prop']").innerHTML = '속성(전체)'
            }else{
              document.getElementById('sel-prop').parentNode.parentNode.querySelector("label[for='sel-prop']").innerHTML = '속성'
            }
            this.propChange()
            break;
          case 'prop_d':
            if(this.filterData.prop_d.length == 0 || this.filterData.prop_d.length == this.optionData.prop_d.length){
              document.getElementById('sel-prop-details').parentNode.parentNode.querySelector("label[for='sel-prop-details']").innerHTML = '세부 속성(전체)'
            }else{
              document.getElementById('sel-prop-details').parentNode.parentNode.querySelector("label[for='sel-prop-details']").innerHTML = '세부 속성'
            }
            break;
          default:
            break;
        }
      },

      removeSelItem(type, target, sel_idx) {
        target.splice(sel_idx, 1)
        target = [...target]

        if(type == 'prop')
          this.propChange()

        this.changeFilter(type)
      },

      datePickerOnOpen(selectedDates, dateStr, instance) {
        if (document.querySelector(".fp-max-duration-info") == null) {
          var divEl = document.createElement("div"); 
          divEl.setAttribute('class', 'fp-max-duration-info');   
          divEl.setAttribute('align', 'left');   
          divEl.setAttribute('style', 'margin: 2px 10px; font-family: NanumBarunGothic; font-size: 12px; font-weight: 600; color: #17a2b8;');   
          divEl.innerHTML = "&#9888; 분석기간은 최대 3년 입니다.";
          document.querySelector(".flatpickr-calendar").appendChild(divEl);
        }
      },

      datePickerOnChange(selectedDates, dateStr, instance) {
        instance.element.value = dateStr.replace('to', '~')

        var [st_dt, en_dt] = selectedDates;
        
        if (en_dt == null) {
          var newMindate = moment(st_dt).add(-35, 'month')
          var newMaxdate = moment(st_dt).add( 35, 'month')

          if (newMindate.isBefore(this.configs.monthSelect.minDate)) 
            newMindate = moment(this.configs.monthSelect.minDate);

          if (newMaxdate.isAfter(this.configs.monthSelect.maxDate)) 
            newMaxdate = moment(this.configs.monthSelect.maxDate);

          instance.config.minDate = newMindate.toDate()
          instance.config.maxDate = newMaxdate.toDate()
        }
      },

      datepickerCloseHandler(selectedDates, dateStr, instance) {
        var [st_dt, en_dt] = selectedDates;

        if (en_dt) {
          var diff_month = (en_dt.getYear() - st_dt.getYear()) * 12 + (en_dt.getMonth() - st_dt.getMonth() + 1);

          if (diff_month > 36) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "설정 가능한 최대 분석 기간은 3년(36개월)입니다." || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "warning",
              },
            });

            var curr_dt = new Date()
            var avail_diff_month = (curr_dt.getYear() - st_dt.getYear()) * 12 + (curr_dt.getMonth() - st_dt.getMonth());

            if (avail_diff_month > 35)
              avail_diff_month = 35
            
            en_dt = moment(st_dt).add(avail_diff_month, 'month').toDate()

            this.form.monthSelect = [st_dt, en_dt]
          }
          else
            this.form.monthSelect = selectedDates;

          var st_dt_str = moment(st_dt).format("YYYY-MM")
          var en_dt_str = moment(en_dt).format("YYYY-MM")

          if(this.selectedDates[0] != st_dt_str || this.selectedDates[1] != en_dt_str){
            this.selectedDates = []
            this.selectedDates.push(st_dt_str)
            this.selectedDates.push(en_dt_str)

            for (var btn_idx = 0; btn_idx < this.dsp_buttons.length; btn_idx++)
              this.dsp_buttons[btn_idx].state = false;

            this.loadData(moment(st_dt).format("YYYY-MM"), moment(en_dt).format("YYYY-MM"));

            this.$store.dispatch('callPeriodSt', { st_dt: st_dt })
            this.$store.dispatch('callPeriodEn', { en_dt: en_dt })
          }
        }
        else
          instance.setDate([this.form.monthSelect[0], this.form.monthSelect[1]], true)
      },

      async propChange() {
        this.optionData.prop_d = [];
        this.filterData.prop_d = [];

        if (this.filterData.prop != null && this.filterData.prop.length > 0) {
          var st_dt_str = moment(this.form.monthSelect[0]).format("YYYY-MM")
          var en_dt_str = moment(this.form.monthSelect[1]).format("YYYY-MM")
         
          const response = await TrackingService.getPropDetail({
            prop: this.filterData.prop,
            propColNm: this.matchColName(this.filterData.prop),
            st_dt: st_dt_str,
            en_dt: en_dt_str,
            ctgSq: sel_category
          }, source);

          console.log('---------- propChange ----------')
          console.log(response)

          if (response && response.status === 200) {
            this.optionData.prop_d = [];
            this.filterData.prop_d = [];

            this.optionData.prop_d = this.removeNullString(response.data.split(','));
          }
        }
      },

      matchColName(propNm) {
        var ret = [];

        if (propNm != null && propNm.length > 0) {
          for(const prop of propNm)
            ret.push(colNameDict[prop])          
        }

        return ret;
      },

      async loadOptions() {
        console.log('---------- loadOptions ----------')

        this.filterData.brands = this.optionData.brands;

        this.filterData.dateType = this.optionData.dateType[1] // 기본 날짜 형식은 '주'
        this.filterData.legendType = this.optionData.legendType[0]
        this.filterData.displayType = this.optionData.displayType[1]

        this.dsp_buttons[0].state = true;

        this.$store.dispatch('callTrackingDisplayType', { displayType: this.optionData.displayType[1] })
        this.$store.dispatch('callTrackingPeriodType', { periodType: this.optionData.dateType[1] }) // 기본 날짜 형식은 '주'
      },

      removeNullString(arrString) {
        var ret = [];

        for (const str of arrString) {
          if(str.length > 0) {
              ret.push(str);
          }
        }

        return ret;
      },

      filterLegendChange(selLegendIdx) {
        for (var btn_idx = 0; btn_idx < this.dsp_buttons.length; btn_idx++) {
          if (btn_idx == selLegendIdx)
            continue

          this.dsp_buttons[btn_idx].state = false;
        }

        this.filterData.legendType = this.optionData.legendType[selLegendIdx]
        this.filterChange()
      },

      filterChange() {
        this.loadTrackingInfo();
      },

      filterPeriodChange(value) {
        this.filterData.dateType = value
        this.$store.dispatch('callTrackingPeriodType', { periodType: value })

        this.filterChange()
      },

      filterDisplayChange(value) {
        this.filterData.displayType = value
        this.$store.dispatch('callTrackingDisplayType', { displayType: value })
      },

      async loadData(st_dt, en_dt) {
        console.log('---------- loadData1 ----------')
        console.log(' sel category : ' + this.$store.getters.getSelectedCategory)
        console.log(' cur category : ' + sel_category)

        // line 초기화
        if(document.getElementById('loadingLine')){
          document.getElementById('loadingLine').style.visibility = "visible";
        }        
        
        if(document.getElementById('lineChart')){
          document.getElementById('lineChart').style.visibility = "hidden";
        }

        // 카테고리 정보가 설정되지 않은 경우 리턴
        if (sel_category == '9999' && this.$store.getters.getSelectedCategory == '9999') 
            return;
        
        sel_category = this.$store.getters.getSelectedCategory;
        
        const response = await TrackingService.getallpropbyperiod(st_dt, en_dt, sel_category, source);

        console.log('---------- loadData2 ----------')
        console.log(response)

        if (response && response.status === 200) {
          this.optionData.brands = [];
          this.optionData.majors = [];
          this.optionData.middles = [];
          this.optionData.prop = [];
          this.optionData.prop_d = [];

          for(const item of response.data.data) {
            if (item == null)
              continue;
            
            this.optionData.brands = this.removeNullString(item.brand.split(','));
            this.optionData.majors = this.removeNullString(item.major.split(','));
            this.optionData.middles = this.removeNullString(item.middle.split(','));
            this.optionData.prop = this.removeNullString(item.prop.split(','));
          }

          // 중분류 항목 중 '기타' 항목을 '중분류 없음'으로 변경 처리 (TBWA 요청사항)
          var _idx = this.optionData.middles.findIndex((element) => element == "기타");

          if (_idx >= 0) {
            this.optionData.middles = this.optionData.middles.with(_idx, "중분류 없음")
            this.optionData.middles.sort()
          }

          await this.loadOptions();
          this.loadTrackingInfo();
        }
      },

      async loadTrackingInfo() {
        // line 초기화
        document.getElementById('loadingLine').style.visibility = "visible";
        document.getElementById('lineChart').style.visibility = "hidden";
        
        this.lnChartInit = false;
        this.lineChartData = [];
        this.lineChartCategories = [];

        var st_dt_str = moment(this.form.monthSelect[0]).format("YYYY-MM")
        var en_dt_str = moment(this.form.monthSelect[1]).format("YYYY-MM")
        
        var filter_middle = this.filterData.middles;

        if (this.filterData.middles.length > 0) {
          // 선택 항목 중 '중분류 없음' 항목이 존재하는 경우 '기타'로 변경 처리 (TBWA 요청사항)
          var _idx = this.filterData.middles.findIndex((element) => element == "중분류 없음");

          if (_idx >= 0) {
            filter_middle = this.filterData.middles.with(_idx, "기타");
            filter_middle.sort()
          }
        }

        const response = await TrackingService.getTrackingInfo({
          st_dt: st_dt_str,
          en_dt: en_dt_str,
          ctgSq: sel_category,

          dateType: this.filterData.dateType,
          criteria: this.filterData.legendType,
          displayType: this.filterData.displayType,

          selBrand: this.filterData.brands,
          selMajor: this.filterData.majors,
          selMiddle: filter_middle,
          selProp: this.filterData.prop,
          selPropColNm: this.matchColName(this.filterData.prop),
          selPropDetails: this.filterData.prop_d,
        }, source);

        console.log('---------- loadTrackingInfo ----------')
        console.log(response)

        if (response && response.status === 200) {
          this.lnChartInit = true;
          this.lineChartData = [];
          this.lineChartCategories = [];

          for(const item of response.data.data) {
            this.lineChartData.push({
              criteria: this.filterData.legendType == '중분류' ? item.criteria.replace('기타', '중분류 없음') : item.criteria,
              type: 'line',
              data: item.searchVol.split(','),
              hidden: item.rank > 5 ? true : false
            })

            if (this.lineChartCategories.length == 0) {
              this.lineChartCategories = item.date.split(',')
            }
          }

          // 조회 기간 동안 최대 검색량을 기록한 브랜드 및 날짜 정보를 획득 
          this.top_freq_brand = "";
          this.top_freq_date = "";
          this.top_freq_value = 0;
          this.top_freq_rate = 0.0;

          var totalFreqList = []

          for (let i = 0; i < this.lineChartCategories.length; i++) {
            var totalFreq = 0;

            for (var item of this.lineChartData)
              totalFreq += Number(item.data[i])

            totalFreqList.push(totalFreq)
          }

          for(var item of this.lineChartData) {
            var index = 0;

            for(var freq of item.data) {
              if(parseInt(freq) > this.top_freq_value) {
                this.top_freq_value = parseInt(freq)
                this.top_freq_rate = parseInt(freq) / totalFreqList[index] * 100
                this.top_freq_brand = item.criteria
                this.top_freq_date = this.lineChartCategories[index]
              }
              
              index++;
            }
          }

          document.getElementById('loadingLine').style.visibility = "hidden";
          document.getElementById('lineChart').style.visibility = "visible";
        }
      },

      handleResize(event) {
        // Chart의 높이 조정 시 Re-rendering 되면서, 다시 mount되는 문제 발생
        // 기존 작업 데이터가 초기화되는 오류를 개선하지 못하여 해당 이벤트는 적용하지 않는다.
        this.lnChartHeight = window.innerHeight - 460 + 'px'
      },

      getToday() {
        let date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth() < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
        let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

        return year + month + day
      },

      exportToPDF: _.debounce(async function() {
        this.isPdfExporting = true;

        await sleep(1);

        var ret = await ExportPDF.exportToPDF([this.$refs.trkPrintArea], 'a4', 'l', 'tracking_' + this.getToday() + '.pdf');

        if (ret) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "PDF export complete!!",
              icon: "EditIcon",
              variant: "success",
            },
          });
        }
        else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "PDF export fail!!",
              icon: "AlertCircleIcon",
              variant: "warning",
            },
          });
        }

        this.isPdfExporting = false;
      }, 100),

      newSheet4Intro(dataOrigin, category, period, serviceName) {
        var tmp_sheet = []

        tmp_sheet.push([]);
        tmp_sheet.push(['', { v: 'CONSUMER in SEARCH Ai', t: "s", s: boldStyle }]);
        tmp_sheet.push(['', { t: "s", v: "consumerinsearch.com", l: {Target: "https://consumerinsearch.com"}, s: underlineStyle}]);
        tmp_sheet.push([]);
        tmp_sheet.push(['', { v: '데이터 개요', t: "s", s: boldStyle }]);
        tmp_sheet.push(['', { v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
        tmp_sheet.push(['', { v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
        tmp_sheet.push(['', { v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
        tmp_sheet.push(['', { v: '서비스명: ', t: "s", s: boldStyle }, { v: serviceName, t: "s", s: boldStyle }]);

        var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
        ws['!cols'] = this.autoFit(tmp_sheet)

        return ws;
      },

      newSheet4Data(dataOrigin, category, period, columns, data) {
        var tmp_sheet = [];

        // Information
        tmp_sheet.push([{ v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
        tmp_sheet.push([{ v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
        tmp_sheet.push([{ v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
        tmp_sheet.push([]);

        // Header
        var header_list = ['No.', '키워드'].concat(columns)
        var tmp_header = [];

        for (const col_nm of header_list) {
          tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
        };

        tmp_sheet.push(tmp_header);

        // Data
        for (const idx in data) {
          var tmp_row = [];
          tmp_row.push(Number(idx) + 1);
          tmp_row.push(data[idx].criteria);

          for (const sub_item of data[idx].data) {
            tmp_row.push({ t: "n", v: Number(sub_item), s: intNumStyle });
          };

          tmp_sheet.push(tmp_row)
        }

        var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
        ws['!cols'] = this.autoFit(tmp_sheet)

        return ws;
      },

      autoFit(data) {
        const wsCols = [];

        data.map((item) => {
          Object.keys(item).map((key, index) => {
            let text = item[key];
            let maxWidth;

            switch(typeof text) {
              case 'number':
                if (wsCols[index]) {
                  if (text)
                    maxWidth = wsCols[index].width > 10 ? wsCols[index].width : 10;
                  else
                    maxWidth = 10;
                }
                else
                  maxWidth = text !== null ? 10 : 0;
                          
                break;
              case 'object':
                if (wsCols[index]) {
                  if (text && text['v']) {
                    if (typeof text['v'] === 'number')
                      maxWidth = wsCols[index].width > 10 ? wsCols[index].width : 10;
                    else
                      maxWidth = wsCols[index].width < text['v'].length * 1.5 ? text['v'].length * 1.5 : wsCols[index].width;
                  }
                  else
                    maxWidth = wsCols[index].width;
                }
                else {
                  if (text && text['v']) {
                    if (typeof text['v'] === 'number')
                      maxWidth = text['v'] !== null ? 10 : 0;
                    else
                      maxWidth = text['v'] !== null ? text['v'].length * 1.5 : 0;
                  }
                  else
                      maxWidth = 0;
                }

                break;
              case 'string':
                if (wsCols[index]) {
                  if (text)
                    maxWidth = wsCols[index].width < text.length * 1.5 ? text.length * 1.5 : wsCols[index].width;
                  else 
                    maxWidth = wsCols[index].width;
                }
                else 
                  maxWidth = text !== null ? text.length * 1.5 : 0;
                
                break;
            }

            wsCols[index] = {width : maxWidth}
          })
        })

        for (var index in wsCols)
          wsCols[index].width = wsCols[index].width === 0 ? 10 : wsCols[index].width * 1.5;

        return wsCols
      },

      exportToExcel: _.debounce(async function() {
        const XLSX = require("xlsx-js-style");

        this.isXlsExporting = true;

        await sleep(1);

        try {
          var st_dt_str = moment(this.form.monthSelect[0]).format("YYYY-MM")
          var en_dt_str = moment(this.form.monthSelect[1]).format("YYYY-MM")

          const dataOrigin = 'NAVER';
          var category = 'Unknown';

          const response = await CategoryService.getOneCategory(sel_category, source);

          console.log('---------- exportToExcel ----------')
          console.log(response)

          if (response.data.success)
            category = response.data.data.title

          const period = st_dt_str + ' ~ ' + en_dt_str;

          const workbook = XLSX.utils.book_new()	// 엑셀 생성
          
          XLSX.utils.book_append_sheet(workbook, 
                                        this.newSheet4Intro(dataOrigin, category, period, 'TRACKING'), 
                                      '데이터 개요') 
          XLSX.utils.book_append_sheet(workbook, 
                                        this.newSheet4Data(dataOrigin, category, period, this.lineChartCategories, this.lineChartData), 
                                      'TRACKING')

          XLSX.writeFile(workbook, 'tracking_' + this.getToday() + '.xlsx')	// 엑셀 다운로드

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Excel export complete!!",
              icon: "EditIcon",
              variant: "success",
            },
          });
        }
        catch (err) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Excel export fail!!",
              icon: "AlertCircleIcon",
              variant: "warning",
            },
          });
        }

        this.isXlsExporting = false;
      }, 100),

      abort(isReset, message) {
        console.log('---------- abort ---------- // ' + message)

        // cancel the request
        source.cancel(message);

        if (isReset)
          source = cancelToken.source();
      },

      selectAll(type) {
        if (type == 'brand') {
          if (this.isSelectAll_brands)
            this.filterData.brands = []
          else
            this.filterData.brands = this.optionData.brands
        }
        else if (type == 'major') {
          if (this.isSelectAll_majors)
            this.filterData.majors = []
          else
            this.filterData.majors = this.optionData.majors
        }
        else if (type == 'middle') {
          if (this.isSelectAll_middles)
            this.filterData.middles = []
          else
            this.filterData.middles = this.optionData.middles
        }
        else if (type == 'prop') {
          if (this.isSelectAll_props)
            this.filterData.prop = []
          else
            this.filterData.prop = this.optionData.prop

          this.propChange()
        }
        else {
          if (this.isSelectAll_prop_details)
            this.filterData.prop_d = []
          else
            this.filterData.prop_d = this.optionData.prop_d
        }
      },

      formatDateToYYYYMMDD(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so add 1
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },

      async getSearchVolDiff(keyword, st_dt) {
        if(keyword == '중분류 없음')
          keyword = '기타'

        const sel_category = this.$store.getters.getSelectedCategory
        const criteria = this.filterData.legendType
        const date_type = this.filterData.dateType
        const display_type = this.filterData.displayType
        const sel_brand = this.filterData.brands
        const sel_major = this.filterData.majors
        var filter_middle = this.filterData.middles;

        if (this.filterData.middles.length > 0) {
          // 선택 항목 중 '중분류 없음' 항목이 존재하는 경우 '기타'로 변경 처리 (TBWA 요청사항)
          var _idx = this.filterData.middles.findIndex((element) => element == "중분류 없음");

          if (_idx >= 0) {
            filter_middle = this.filterData.middles.with(_idx, "기타");
            filter_middle.sort()
          }
        }

        const sel_middle = filter_middle
        const sel_prop = this.filterData.prop
        const sel_prop_col_nm = this.matchColName(this.filterData.prop)
        const sel_prop_details = this.filterData.prop_d

        var ret = [];

        var en_date = "";
        var pr_date = "";
        var en_date_str = "";
        var pr_date_str = "";

        var prd_st_dt = moment(new Date(moment(this.form.monthSelect[0]).format("YYYY-MM"))).format("YYYY-MM-DD")
        var prd_en_dt = moment(new Date(moment(this.form.monthSelect[1]).add(1, 'month').format('YYYY-MM'))).add(-1, 'day').format("YYYY-MM-DD")

        const prd_st = new Date(prd_st_dt);
        const prd_en = new Date(prd_en_dt);

        const st_date = new Date(st_dt);
        const st_date_str = this.formatDateToYYYYMMDD(st_date);

        switch (date_type) {
          case "주": {
            en_date = new Date(st_date.setDate(st_date.getDate() + 7))
            pr_date = new Date(st_date.setDate(st_date.getDate() - 14))
            break;
          }
          case "일": {
            en_date = new Date(st_date.setDate(st_date.getDate() + 3))
            pr_date = new Date(st_date.setDate(st_date.getDate() - 6))
            break;
          }
        }

        if (prd_en < en_date)
          en_date_str = this.formatDateToYYYYMMDD(prd_en)
        else
          en_date_str = this.formatDateToYYYYMMDD(en_date)

        if (prd_st > pr_date)
          pr_date_str = this.formatDateToYYYYMMDD(prd_st)
        else
          pr_date_str = this.formatDateToYYYYMMDD(pr_date)

        const response = await TrackingService.getHighDiffKeywords({
          st_dt: st_date_str,
          en_dt: en_date_str,
          pr_dt: pr_date_str,
          ctgSq: sel_category,

          dateType: date_type,
          criteria: criteria,
          displayType: display_type,

          selBrand: sel_brand,
          selMajor: sel_major,
          selMiddle: sel_middle,
          selProp: sel_prop,
          selPropColNm: sel_prop_col_nm,
          selPropDetails: sel_prop_details,
          text: keyword
        }, source);

        console.log('---------- getHighDiffKeywords ----------')
        console.log(response)

        if (response && response.status === 200) {
          ret = response.data.data;
        }

        return ret;
      },
    },

    mounted(){
      console.log('---------- mounted ----------')
      console.log(' sel category : ' + this.$store.getters.getSelectedCategory)

      setTimeout(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }, 200);

      // console.log('--> add event : windows resize')
      // window.addEventListener('resize', _.debounce(this.handleResize, 500));
    },

    // unmounted() {
    //   console.log('---------- unmounted ----------')
    //   console.log('--> remove event : windows resize')
    //   window.removeEventListener('resize', this.handleResize);
    // },

    destroyed() {
      console.log('---------- destroyed ----------')
      
      this.abort(false, 'destoryed')
    },

    created() {
      console.log('---------- create ----------')

      this.abort(true, 'created')

      this.$store.dispatch('callCISMenu', { cisMenu: 'tracking' })

      this.lnChartHeight = window.innerHeight - 460 + 'px'

      var st_dt = this.$store.getters.getSelectedPeriodSt
      var en_dt = this.$store.getters.getSelectedPeriodEn

      if (st_dt.length == 0 || en_dt.length == 0) {
        en_dt = moment().add(-2, 'days').toDate() // 이번 달 말일로 지정
        st_dt = new Date(en_dt)

        st_dt.setMonth(en_dt.getMonth() - 11)
      }

      this.form.monthSelect = [st_dt, en_dt]

      var st_dt_str = moment(st_dt).format("YYYY-MM")
      var en_dt_str = moment(en_dt).format("YYYY-MM")

      this.selectedDates.push(st_dt_str)
      this.selectedDates.push(en_dt_str)

      for (var btn_idx = 0; btn_idx < this.dsp_buttons.length; btn_idx++)
        this.dsp_buttons[btn_idx].state = false;

      this.loadData(moment(st_dt).format("YYYY-MM"), moment(en_dt).format("YYYY-MM"));
    },

    setup(props) {
      return {
      };
    },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.trkvsellabel .v-label {
  font-size: 12px;
  font-weight: 600;
}

.trkselectitemlist .v-list-item {
  min-height: 28px;
}

.trkselectitemlist .v-list-item__content {
  padding: 3px 0px;
}

.trkselectitemlist .v-list-item__action {
  margin: 3px 0px;
}

.trkselectitemlist .v-list-item__action:first-child {
  margin-right: 15px;
}

.trkselectitemlist .v-list-item__title {
  font-size: 12px;
  font-weight: 600;
}

.trkselectallitem {
  margin: 0px !important;
  padding: 0px !important;
}

.trkselectallitem .v-input__slot {
  padding: 0 16px;
}

.trkdivider {
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
}

.mb-1 .sticky-top{
  align-self: flex-start;
}

.tooltip-inner {
  color: #333;
  background: #fff;
  border: 1px solid #F2F2F2;
  font-family: "NanumBarunGothic", Arial, sans-serif !important;
  filter: none;
  box-shadow: 1px 1px 1px #F2F2F2;
  font-weight: bold;
}

.dsp-opt-btn {
  height: 28px; 
  width: 100px; 
  padding: 0.4rem 0.2rem; 
  margin: 2px; 
  border-radius: 0.38rem;
  background-color: #4E86FF !important; 
  border-color: #4E86FF !important;
}
</style>